import ProjectPage from "../../components/ProjectPage";

// To add a real screenshot: drop the file into src/assets/, import it here
// (e.g. `import shot from "../../assets/vitaelum-web.png";`), then add
// `src: shot` to the matching frame below.
export default function Vitaelum() {
  return (
    <ProjectPage
      title="Vitaelum"
      category="Mobile / Web"
      tagline="Personal portfolio with live iPhone Focus-state integration."
      body={[
        "This site itself. The landing mood syncs in real time with my iPhone Focus state — when I switch Focus modes on my phone, the site's atmosphere shifts with it.",
        "Built with React, CSS scroll-snap, and a small serverless API the landing section polls for the current Focus state.",
      ]}
      art="linear-gradient(200deg, rgba(var(--text-rgb), 0.14) 0%, rgba(var(--text-rgb), 0.02) 72%)"
      // tech + features are draft copy — edit freely
      tech={["React", "CSS scroll-snap", "Vercel serverless", "iOS Focus / Shortcuts"]}
      features={[
        {
          title: "Live Focus-state gradient",
          desc: "The hero palette shifts with my iPhone Focus mode, polled every 15 seconds.",
        },
        {
          title: "Full-viewport snap sections",
          desc: "CSS scroll-snap keeps every section perfectly framed.",
        },
        {
          title: "Serverless focus API",
          desc: "An iOS Shortcut posts the current Focus state to a Vercel function.",
        },
        {
          title: "Session scroll restoration",
          desc: "Returning from a project page lands you exactly where you left off.",
        },
      ]}
      githubNote="Private repository"
      frames={[
        { type: "web", label: "Web — screenshot coming" },
        { type: "mobile", label: "Mobile — screenshot coming" },
      ]}
    />
  );
}
